import React, { useEffect, useState, useCallback } from "react";
import { fetchConsentText } from "../utils/api";

export default function ConsentModal({ isOpen, onClose, onAgree, language }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const loadText = useCallback(async () => {
    setLoading(true);
    try {
      const content = await fetchConsentText(language || "en");
      setText(
        content
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/\n/g, "<br>")
      );
    } catch {
      setText(
        "<p><strong>Informed Consent — Summary</strong></p>" +
        "<p>This document explains what types of biological samples (blood, tissue, urine, saliva, etc.) and coded health information will be stored and used for approved research. Your name and contact details will not be shared with researchers. Participation is voluntary and you may withdraw at any time in writing.</p>"
      );
    }
    setLoading(false);
  }, [language]);

  useEffect(() => {
    if (isOpen) loadText();
  }, [isOpen, loadText]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h5 className="modal-heading">Biobank Informed Consent</h5>
        </div>
        <div className="modal-scroll-body">
          {loading ? (
            <div className="modal-loading">Loading consent text...</div>
          ) : (
            <div className="consent-text" dangerouslySetInnerHTML={{ __html: text }} />
          )}
        </div>
        <div className="modal-foot">
          <button className="btn-primary-action" onClick={onAgree}>
            I Agree &amp; Continue
          </button>
        </div>
      </div>
    </div>
  );
}
